import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Insert your verification code below:", -1)
const _hoisted_2 = { class: "field flex flex-column gap-2 align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "In case you didn't recive any email, request a new one", -1)
const _hoisted_4 = { key: 1 }

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '../stores/UserStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { ErrorMessage, GenericObject, useForm } from 'vee-validate';
import * as yup from 'yup';
import { RequestStatus } from '@/models/request.model';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserEmailConfirm',
  setup(__props) {

const route = useRoute(); 
const userStore = useUserStore();
const apiStatusStore = useApiStatusStore();

const emailVerifCode = route.params.emailVerifCode as string | undefined;

onMounted(() => {
  console.log('emailVerifCode', emailVerifCode);
  if(emailVerifCode){
    userStore.confirmEmail(emailVerifCode);
  }
});

const ctaLabel = computed(() => {
  const apiStatus = apiStatusStore.getRequestStatus('post_user_email-verify');
  switch (apiStatus){
    case RequestStatus.Pending :
      return 'Confirming...'
    case RequestStatus.Rejected :
      return 'Confirm email'
    case RequestStatus.Fulfilled :
      return 'Email confirmed'
    default:
      return 'Confirm email';
  }     
});

const schema = yup.object().shape({
  code: yup.string().required().label('code'),
});

const { defineField, handleSubmit } = useForm({
  validationSchema: schema,
});

const [code] = defineField('code');

const onSubmit = handleSubmit((values: GenericObject) => {
  userStore.confirmEmail(values.code);
});

function onRequestNewEmailConfirm(){
  userStore.requestConfirmEmail();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(InputText), {
          modelValue: _unref(code),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(code) ? (code).value = $event : null)),
          id: "code",
          type: "code"
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(ErrorMessage), { name: "code" })
      ]),
      _createVNode(_unref(Button), {
        type: "submit",
        label: ctaLabel.value,
        disabled: _unref(apiStatusStore).requests.get('post_user_email-verify') && _unref(apiStatusStore).requestFulfilled('post_user_email-verify')
      }, null, 8, ["label", "disabled"])
    ], 32),
    _hoisted_3,
    (!_unref(apiStatusStore).requests.get('get_user_send-email-verify'))
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onRequestNewEmailConfirm())),
          label: "Request verification email"
        }))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "Verification email requested."))
  ], 64))
}
}

})